import Vue from 'vue'
import Helper from '@/helper/helper.js'

///////////////////////////////////////////////////////////////////////////////
// миксины, которые используются не часто
///////////////////////////////////////////////////////////////////////////////
const Mixins = {
	//=========================================================================
	// mixin'ы - методы будут доступны из любого компонента где прописан этот mixin
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// получить данные из удаленного хранилища
		// данные приходят ВСЕ сразу - поэтому эту функцию лучше не дергать часто
		// при аутентификации эти данные всегда запрашиваются
		// и хранятся в $store.state.userServerOptions
		//---------------------------------------------------------------------
		remoteStorageGet: function(key) {
			return new Promise(resolve => {
				// только для аутентифицированного пользователя
				if (!this.$store.state.is_auth)
					return resolve(null)

				// запросим данные
				this.$http.get(Vue.APIServerUrl + '/option/get')
				// успешный ответ
				.then(response => {
					// если ответ корректный
					if (response &&
						response.data &&
						response.data.status === 'ok' &&
						response.data.option && Array.isArray(response.data.option) && response.data.option.length)
					{
						// ищем данные по ключу
						response.data.option.some(item => {
							if (typeof item === 'object')
							{
								for (let _prop in item) if (item.hasOwnProperty(_prop))
								{
									if (_prop === key)
										return resolve(item[_prop])
								}
							}
						})
					}

					resolve(null)
				})
				// ошибка
				.catch(() => resolve(null))
			})
		},
		//---------------------------------------------------------------------
		// записать данные в удаленное хранилище
		//---------------------------------------------------------------------
		remoteStorageSet: function(key, value) {
			return new Promise((resolve, reject) => {
				// только для аутентифицированного пользователя
				if (!this.$store.state.is_auth)
					return resolve(null)

				// сохраним данные
				this.$http.post(Vue.APIServerUrl + '/option/set/' + key, Helper.toFormData({ value }))
				// успешный ответ
				.then(response => {
					// если ответ корректный
					if (response && response.data && response.data.status === 'ok')
						return resolve()

					reject({ name: 'remoteStorage', message: 'error/api_incorrect' })
				})
				// ошибка
				.catch(res => {
					let _errMsg = 'error/api_incorrect'

					if (res && res.data && typeof res.data === 'object' &&
						'title' in res.data && res.data['title'] && res.data['title'].length)
						_errMsg = 'main/error_desc ' + res.data['title']

					if (res && res.data && typeof res.data === 'object' &&
						'content' in res.data && res.data['content'] && res.data['content'].length)
						_errMsg = 'main/error_desc ' + res.data['content']

					reject({ name: 'remoteStorage', message: _errMsg })
				})
			})
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}

export default Mixins



// WEBPACK FOOTER //
// ./src/mixins/index.js